import * as React from 'react';
import SubHeader from "components/menu/SubHeader";
import { Card } from "reactstrap";

export default () =>
    <div className="narrow-container">
        <SubHeader />

        <Card className="primary-card">
            <h2>Under Construction</h2>

            <h3>This page is coming in a future release</h3>
        </Card>
    </div>;